export default __webpack_public_path__ + "static/media/3s.fe4fcc87.svg";